import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Module } from '../../shared/objects/auth/module';

@Injectable()
export class PermissionAuthGuard  {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot) {
    const allowedPermissions: Module[] = route.data['allowedPermissions'];
    const userPermissions = this.authService.getUserFeatureClaims();

    const userHasAccess = userPermissions.some(p =>
      allowedPermissions.includes(p)
    );

    if (userHasAccess) {
      return true;
    } else {
      this.router.navigate(['/secure/dashboard']);
      return false;
    }
  }
}
